<script lang="ts" setup>
import { TaskImportServiceEnum } from "@/enums";
import {
  TirPmButton,
  TirPmDropdown,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";
import { TaskImportDropdownOptionModel } from "./models";
import { ArrowDownTrayIcon } from "tir-style-system/icons/solid";
import { CrossLinedIcon } from "tir-style-system/icons/outline";
import { PropType } from "vue";

const props = defineProps({
  /**Выбранный сервис */
  modelValue: { type: String as PropType<TaskImportServiceEnum> },
});

const emit = defineEmits<{
  "update:modelValue": [service: TaskImportServiceEnum | undefined];
}>();

const options: TaskImportDropdownOptionModel[] = [
  new TaskImportDropdownOptionModel({
    Id: TaskImportServiceEnum.Weeek,
    Text: "Weeek.ru",
  }),
];

/**Обработчик клика на кнопку */
const onClickButton = (event: MouseEvent) => {
  if (props.modelValue !== undefined) {
    event.stopPropagation();
    emit("update:modelValue", undefined);
  }
};
</script>

<template>
  <TirPmDropdown
    :options="options"
    :popover-position="{
      left: '-0.625rem',
      top: '$el:height',
    }"
    :is-disabled="modelValue !== undefined"
  >
    <template #target="{ isOpened }">
      <TirPmButton
        :variant="TirPmButtonVariantEnum.SecondaryState"
        :size="TirPmButtonSizeEnum.Small"
        @click="onClickButton"
      >
        <template #leftSlot>
          <div class="task-import-button__icon">
            <ArrowDownTrayIcon v-if="!isOpened && modelValue === undefined" />
            <CrossLinedIcon v-else />
          </div>
        </template>
      </TirPmButton>
    </template>
    <template #optionList="{ option }">
      <div class="task-import-button__option" @click="emit('update:modelValue', option.Id)">
        {{ option.Text }}
      </div>
    </template>
  </TirPmDropdown>
</template>

<style lang="scss" scoped>
.task-import-button {
  &__icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: "";
      position: absolute;
      z-index: 2;
      display: block;
      left: 0;
      bottom: 0;
      right: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__option {
    color: var(--text-primary, #272d37);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    padding: 12px;
  }
}
</style>
